import * as organizationConstants from '../constants/organizations';

const INITIAL_STATE = {
    newOrgName: undefined,
    loading: false,
    error: undefined,
    gaLoading: false,
    gaError: undefined,
    ga: undefined,
};

export default function organizationSettings(state = {}, action) {
    switch (action.type) {
        case organizationConstants.RESET_ORGANIZATION_SETTINGS:
            return {
                ...INITIAL_STATE,
            };
        case organizationConstants.CHANGE_ORGANIZATION_SETTINGS_NAME:
            return {
                ...state,
                newOrgName: action.payload,
            };
        case organizationConstants.CHANGE_ORGANIZATION_SETTINGS_GA:
            return {
                ...state,
                ga: action.payload.ga,
            };
        case organizationConstants.UPDATE_ORGANIZATION_SETTINGS_REQUEST:
            return {
                ...state,
                newOrgName: action.payload,
                loading: true,
                gaLoading: true,
            };
        case organizationConstants.UPDATE_ORGANIZATION_SETTINGS_SUCCESS:
        case organizationConstants.UPDATE_ORGANIZATION_SETTINGS_SKIP:
            return {
                ...state,
                newOrgName: undefined,
                loading: false,
            };
        case organizationConstants.UPDATE_ORGANIZATION_SETTINGS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case organizationConstants.UPDATE_ORGANIZATION_GA_SETTINGS_SUCCESS:
        case organizationConstants.UPDATE_ORGANIZATION_GA_SETTINGS_SKIP:
            return {
                ...state,
                ga: undefined,
                gaLoading: false,
            };
        case organizationConstants.UPDATE_ORGANIZATION_GA_SETTINGS_FAILURE:
            return {
                ...state,
                gaLoading: false,
                gaError: action.payload,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/organizationSettingsReducer.js